import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { triggerSignIn } from '@fiverr-private/identification_triggers';
import { useHeaderContext } from '../../../context/HeaderContext';
import { sendBigQueryEvent } from '../../../../utils/bigQuery';
import { sendMixPanelEvent } from '../../../../utils/mixPanel';
import { BIGQUERY_SIGN_IN_EVENT, LINKS, MIXPANEL_SIGN_IN_EVENT } from '../constants';
import { reportLogoMakerClick } from '../utils';
import { useLogoMakerContext } from '../../../context/LogoMakerContext';

export const TestimonialsLink = () => {
    const {
        user: { id },
    } = useHeaderContext();
    const { isTransparent } = useLogoMakerContext();

    const path = pathfinder('logo_maker_testimonials_page');

    const handleClick = () => {
        reportLogoMakerClick(id, LINKS.TESTIMONIALS);
    };

    return (
        <Button
            rel="nofollow"
            onClick={handleClick}
            href={path}
            intent="secondary"
            variant="ghost"
            size="md"
            colorScheme={isTransparent ? 'white' : undefined}
        >
            <I18n k="header.testimonials" />
        </Button>
    );
};

export const TutorialsLink = () => {
    const {
        user: { id },
    } = useHeaderContext();
    const { isTransparent } = useLogoMakerContext();

    const path = pathfinder('logo_maker_tutorials_page');

    const handleClick = () => {
        reportLogoMakerClick(id, LINKS.TUTORIALS);
    };

    return (
        <Button
            rel="nofollow"
            onClick={handleClick}
            href={path}
            intent="secondary"
            variant="ghost"
            size="md"
            colorScheme={isTransparent ? 'white' : undefined}
        >
            <I18n k="header.logo_maker.tutorials" />
        </Button>
    );
};

export const PricingLink = () => {
    const {
        user: { id },
    } = useHeaderContext();
    const { isTransparent } = useLogoMakerContext();

    const path = pathfinder('logo_maker_pricing_page');

    const handleClick = () => {
        reportLogoMakerClick(id, LINKS.PRICING);
    };

    return (
        <Button
            rel="nofollow"
            onClick={handleClick}
            href={path}
            intent="secondary"
            variant="ghost"
            size="md"
            colorScheme={isTransparent ? 'white' : undefined}
        >
            <I18n k="header.logo_maker.pricing" />
        </Button>
    );
};

export const GoToFiverrLink = () => {
    const {
        user: { id },
    } = useHeaderContext();
    const { isTransparent } = useLogoMakerContext();

    const path = pathfinder('root', {}, { query: { source: 'logo_maker' } });

    const handleClick = () => {
        reportLogoMakerClick(id, LINKS.GO_TO_FIVERR);
    };

    return (
        <Button
            rel="nofollow"
            onClick={handleClick}
            href={path}
            intent="secondary"
            variant="ghost"
            size="md"
            colorScheme={isTransparent ? 'white' : undefined}
        >
            <I18n k="header.go_to_fiverr" />
        </Button>
    );
};

export const SignInLink = () => {
    const { isTransparent } = useLogoMakerContext();

    const path = pathfinder('login', {}, { query: { source: 'top_nav' } });

    const handleClick = async (event) => {
        try {
            event.preventDefault();
            await triggerSignIn({ modalOptions: { source: 'header_login_link' } });
            sendBigQueryEvent(BIGQUERY_SIGN_IN_EVENT);
            sendMixPanelEvent(MIXPANEL_SIGN_IN_EVENT);
        } catch {
            window.location.assign(path);
        }
    };

    return (
        <Button
            rel="nofollow"
            onClick={handleClick}
            href={path}
            intent="secondary"
            variant="ghost"
            size="md"
            colorScheme={isTransparent ? 'white' : undefined}
        >
            <I18n k="header.sign_in" />
        </Button>
    );
};

export const MyLogosLink = () => {
    const { user } = useHeaderContext();
    const { isTransparent } = useLogoMakerContext();

    const path = pathfinder('logo_maker_buyer_saved_logos_page', {}, { query: { source: 'logo_maker' } });

    const handleClick = () => {
        reportLogoMakerClick(user.id, LINKS.SAVED_LOGOS);
    };

    return (
        <Button
            rel="nofollow"
            onClick={handleClick}
            href={path}
            intent="secondary"
            variant="ghost"
            size="md"
            colorScheme={isTransparent ? 'white' : undefined}
        >
            <I18n k="header.my_logos" />
        </Button>
    );
};
